<template>
  <AccountAuthTableView />
</template>

<script>
import AccountAuthTableView from '../../../components/container/AccountAuthTableView.vue';

export default {
  components: { AccountAuthTableView },
};
</script>